export default __webpack_public_path__ + "static/media/flow_vector.eb7c0ab8.png";